






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {ResponsavelAssociado} from '@/model/resource/ResponsavelAssociado'
import {InputResponsavelAssociadoSchema} from '@/schema/resource/ResponsavelAssociado/InputResponsavelAssociadoSchema'

@Component
export default class PersistResponsavelAssociadoView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputResponsavelAssociadoSchema()
  responsavelAssociado = new ResponsavelAssociado()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionResponsavel.listResponsavel()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.responsavelAssociado.getResponsavelAssociado(id)
    }

    $.await.done('getResponsavelAssociado')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.responsavelAssociado.persistResponsavelAssociado()
    await Helper.successAndPush(
      'system.success.persist',
      '/responsavel-associado/list'
    )
  }
}
